<template>
  <div class="select-price-range">
    <AppSelectArray
      :list="getLowerRange"
      :value="selectedFeeLower"
      class="select-price-range__select --lower"
      @changed="value => setValue('lower', value)"
    />
    <div class="select-price-range__unit">～</div>
    <AppSelectArray
      :list="getUpperRange"
      :value="selectedFeeUpper"
      class="select-price-range__select --upper"
      @changed="value => setValue('upper', value)"
    />
  </div>
</template>

<script>
import AppSelectArray from '@/components/elements/AppSelectArray/'

export default {
  components: {
    AppSelectArray
  },
  props: {
    // 下限金額の初期値
    feeLower: {
      type: String,
      required: false,
      default: '0'
    },
    // 上限金額の初期値
    feeUpper: {
      type: String,
      required: false,
      default: '0'
    }
  },
  data() {
    return {
      priceRange: [
        { label: '1,000円', value: '1000', disabled: false },
        { label: '2,000円', value: '2000', disabled: false },
        { label: '3,000円', value: '3000', disabled: false },
        { label: '4,000円', value: '4000', disabled: false },
        { label: '5,000円', value: '5000', disabled: false },
        { label: '6,000円', value: '6000', disabled: false },
        { label: '7,000円', value: '7000', disabled: false },
        { label: '8,000円', value: '8000', disabled: false },
        { label: '9,000円', value: '9000', disabled: false },
        { label: '10,000円', value: '10000', disabled: false },
        { label: '12,000円', value: '12000', disabled: false },
        { label: '14,000円', value: '14000', disabled: false },
        { label: '16,000円', value: '16000', disabled: false },
        { label: '18,000円', value: '18000', disabled: false },
        { label: '20,000円', value: '20000', disabled: false },
        { label: '30,000円', value: '30000', disabled: false },
        { label: '40,000円', value: '40000', disabled: false },
        { label: '50,000円', value: '50000', disabled: false },
        { label: '100,000円', value: '100000', disabled: false },
        { label: '150,000円', value: '150000', disabled: false },
        { label: '200,000円', value: '200000', disabled: false },
      ], // 金額一覧
      selectedFeeLower: this.feeLower, // 選択された下限金額
      selectedFeeUpper: this.feeUpper, // 選択された上限金額
    }
  },
  computed: {
    /**
     * 「下限なし」のlabelを追加した金額一覧
     */
    getLowerRange() {
      const result = window.innerWidth > 639
        ? this.priceRange.map(d => { return { ...d, label: `${d.label} ～` } })
        : this.priceRange

      return [
        { label: '下限なし', value: '0', disabled: false },
        ...result
      ]
    },
    /**
     * 「上限なし」のlabelを追加した金額一覧
     */
    getUpperRange() {
      const setDisablePriceRange = this.priceRange.map(data => {
        const isLowerExceedsUpper = 0 < Number(data.value) && Number(data.value) < Number(this.selectedFeeLower)
        if (isLowerExceedsUpper) {
          return { ...data, disabled: true }
        } else {
          return { ...data, disabled: false }
        }
      })

      const result = window.innerWidth > 639
        ? setDisablePriceRange.map(d => { return { ...d, label: `～ ${d.label}` } })
        : setDisablePriceRange

      return [
        { label: '上限なし', value: '0', disabled: false },
        ...result
      ]
    }
  },
  methods: {
    /**
     * AppSelectが変更されたら値を代入
     * @param {string} type 
     * @param {string} value 
     */
    setValue(type, value) {
      if (type === 'lower') this.selectedFeeLower = value
      if (type === 'upper') this.selectedFeeUpper = value

      const isLowerExceedsUpper =
        0 < Number(this.selectedFeeUpper) &&
        Number(this.selectedFeeUpper) <= Number(this.selectedFeeLower)

      if (isLowerExceedsUpper) {
        this.selectedFeeUpper = this.selectedFeeLower
      }

      this.inputed()
    },
    inputed() {
      this.$emit('inputed', {
        feeLower: this.selectedFeeLower,
        feeUpper: this.selectedFeeUpper
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.select-price-range {
  @include sp {
    align-items: center;
    display: flex;
  }

  &__select {
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    height: 2.5rem;
    width: 100%;

    @include sp {
      width: calc((100% - 2rem) / 2);
    }

    &.--lower {
      margin-bottom: .5rem;
      @include sp {
        margin-bottom: 0;
      }
    }
  }

  &__unit {
    align-items: center;
    display: none;
    justify-content: center;
    width: 2rem;

    @include sp { display: flex; }
  }
}
</style>